// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class MFI extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Money Flow index';
        this.Comments = 'Money Flow index (Volume)';
        this.SetIndicatorLine('MFI', Color.Blue, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Up', 80, Color.Gray, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Down', 20, Color.Gray, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.MFIPeriod = 14;
        super.InputParameter(new InputParameterInteger('MFIPeriod', 'MFI Period', 0, 1, 9999));
    }
    Init() {
        super.Init();
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'MFI(' + this.MFIPeriod + ')';
    }
    createInternalIndicators() {
        this.mfi = this.Indicators.iMFI(this.CurrentData, this.MFIPeriod);
        super.IndicatorShortName(this.GetIndicatorShortName());
        return [this.mfi];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count - 1 < this.MFIPeriod) {
            return;
        }
        const mfi = this.mfi.GetValue();
        super.SetValue(0, mfi);
    }
}
